// src/features/user/ActivityHistory.jsx
import { useGetActivitiesQuery } from "../../../features/api/userApiSlice";
import LoadingSpinner from "../../loader/Loader";
import "./activityHistory.scss";

const ActivityHistory = () => {
  const { data: activities, isLoading, error } = useGetActivitiesQuery();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <p>Failed to load activity history.</p>;
  if (!activities?.length) return <p>No activity recorded yet.</p>;

  return (
    <div className="activity-history">
      {activities?.map((act) => (
        <div key={act._id} className="activity-item">
          <p className="type">{act.type}</p>
          <p className="details">{act.details}</p>
          <p className="date">{new Date(act.timestamp).toLocaleString()}</p>
        </div>
      ))}
    </div>
  );
};

export default ActivityHistory;
